<template>
    <div v-if="showFilters" class="bg-white dark:bg-gray-700 rounded-lg shadow p-4">
        <h2 class="mb-4 text-black dark:text-white">Filters</h2>
        <div class="grid grid-cols-3 gap-4">
            <div
                class="w-full"
            >
                <p class="text-gray-700 dark:text-gray-200 mb-2 text-sm">Software</p>
                <select2
                    :options="software"
                    key="software"
                    :multiple="true"
                    id="software"
                    select-label="name"
                    track-by-option="id"
                    name="software"
                    class="mt-1"
                    @sync="(value) => filterChanged('software', value)"
                    :value="value.software"
                />
            </div>

            <div
                class="w-full"
            >
                <p class="text-gray-700 dark:text-gray-200 mb-2 text-sm">Slot Type</p>
                <select2
                    :options="slotTypes"
                    key="slotTypes"
                    :multiple="true"
                    id="slotTypes"
                    select-label="name"
                    track-by-option="id"
                    name="slotTypes"
                    class="mt-1"
                    @sync="(value) => filterChanged('slotTypes', value)"
                    :value="value.slotTypes"
                />
            </div>

            <div
                class="w-full flex flex-col justify-end"
            >
                <Btn type="button" @click="$emit('filter')" content="Apply Filters"/>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "SlotRankingFilter",
    props: {
        showFilters: {
            type: Boolean,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        },
        language: {
            type: Object,
            required: true,
        },
        software: {
            type: Array,
            required: true,
        },
        slotTypes: {
            type: Array,
            required: true,
        },
    },
    methods: {
        filterChanged(name, value) {
            this.value[name] = value || null
        },
    },
}
</script>
